import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  markNotificationAsRead,
  markAllNotificationsAsRead,
  getNotifications,
} from "libs/api/notification";

// Fetch Notifications Thunk
// Notifications Thunk
export const getNotificationThunk = createAsyncThunk(
  "notification/get",
  async ({
    cbPending,
    cbFulfilled,
    cbRejected,
    cbFinally,
    pathname,
    queryParams,
  }) => {
    try {
      typeof cbPending === "function" && cbPending();
      const response = await getNotifications(pathname, queryParams);
      typeof cbFulfilled === "function" && cbFulfilled();
      return response?.data;
    } catch (error) {
      if (error.response) {
        typeof cbRejected === "function" && cbRejected(error.response);
        throw JSON.stringify(error.response.data);
      } else {
        typeof cbRejected === "function" && cbRejected(error);
        throw JSON.stringify({ message: error.message });
      }
    } finally {
      typeof cbFinally === "function" && cbFinally();
    }
  }
);

// Mark Notification as Read Thunk
export const markNotificationAsReadThunk = createAsyncThunk(
  "notification/markAsRead",
  async ({
    cbPending,
    cbFulfilled,
    cbRejected,
    cbFinally,
    pathname,
    body,
    accessToken,
  }) => {
    try {
      typeof cbPending === "function" && cbPending();
      const response = await markNotificationAsRead(
        pathname,
        body,
        accessToken
      );
      typeof cbFulfilled === "function" && cbFulfilled();
      return response;
    } catch (error) {
      if (error.response) {
        typeof cbRejected === "function" && cbRejected(error.response);
        throw JSON.stringify(error.response.data);
      } else {
        typeof cbRejected === "function" && cbRejected(error);
        throw JSON.stringify({ message: error.message });
      }
    } finally {
      typeof cbFinally === "function" && cbFinally();
    }
  }
);

// Mark All Notifications as Read Thunk
export const markAllNotificationsAsReadThunk = createAsyncThunk(
  "notification/markAllAsRead",
  async ({
    cbPending,
    cbFulfilled,
    cbRejected,
    cbFinally,
    pathname,
    body,
    accessToken,
  }) => {
    try {
      typeof cbPending === "function" && cbPending();
      const response = await markAllNotificationsAsRead(
        pathname,
        body,
        accessToken
      );
      typeof cbFulfilled === "function" && cbFulfilled();
      return response;
    } catch (error) {
      if (error.response) {
        typeof cbRejected === "function" && cbRejected(error.response);
        throw JSON.stringify(error.response.data);
      } else {
        typeof cbRejected === "function" && cbRejected(error);
        throw JSON.stringify({ message: error.message });
      }
    } finally {
      typeof cbFinally === "function" && cbFinally();
    }
  }
);

// Add Notification Action
export const addNotificationThunk = createAsyncThunk(
  "notification/add",
  async ({ notification, cbPending, cbFulfilled, cbRejected, cbFinally }) => {
    try {
      typeof cbPending === "function" && cbPending();
      typeof cbFulfilled === "function" && cbFulfilled();
      return notification;
    } catch (error) {
      typeof cbRejected === "function" && cbRejected(error);
      throw JSON.stringify({ message: error.message });
    } finally {
      typeof cbFinally === "function" && cbFinally();
    }
  }
);
